<template>
  <div class="service-channel">
    <div class="service-item">
      <img src="@/assets/user/kefu_online.png" alt />
      <el-button
        type="primary"
        size="small"
        v-exposure="{ eid: `101_27_0_1` }"
        :data-id="`101_27_0_1`"
        @click="kehubox"
        >{{ $t("Datalang.Invite_TITLE_chat") }}</el-button
      >
    </div>
    <div class="service-item" v-if="getToken && vipKefu.type">
      <img :src="$utils.returnImgUrl(vipKefu.icon)" alt />
      <el-button
        type="primary"
        size="small"
        v-exposure="{ eid: `101_27_0_10` }"
        :data-id="`101_27_0_10`"
        @click="vipKehubox"
        >{{ $t("Datalang.app_support_exclusive") }}</el-button
      >
    </div>
    <div class="service-item" v-for="(item, index) in iconList" :key="index">
      <img :src="$utils.returnImgUrl(item.platformIcon)" alt />
      <el-button
        type="primary"
        size="small"
        v-exposure="{ eid: `101_27_0_${index + 2}` }"
        :data-id="`101_27_0_${index + 2}`"
        @click="onLink(item, `101_27_0_${index + 2}`)"
        >{{ item.platformName }}</el-button
      >
    </div>
    <el-dialog
      v-if="visible"
      :visible.sync="visible"
      append-to-body
      :close-on-press-escape="false"
      :show-close="false"
      destroy-on-close
      :close-on-click-modal="false"
      :top="getIsMobile ? '5vh' : '15vh'"
      custom-class="service-channel-dialog"
    >
      <div class="dialog-content" :class="[getIsMobile ? 'isMobile' : '']">
        <button type="button" class="el-dialog__headerbtn" @click="handleClose">
          <i class="el-dialog__close el-icon el-icon-close"></i>
        </button>
        <img :src="require('@/lobby_common/assets/vip/vip.png')" class="vip-img" alt />
        <div class="vip-text">{{ $t("Datalang.home_meet_vip") }}</div>
        <el-button class="vip-btn" type="primary" @click="handleRecharge">{{
          $t("Datalang.home_Upgrade_VIP")
        }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import serviceChannel from "@/lobby_common/mixins_components/serviceChannel/index.js";
export default {
  components: {},
  props: [],
  mixins: [serviceChannel],
  data() {
    return {};
  },
  filters: {},
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  methods: {},
};
</script>

<style lang="scss" scoped>
.service-channel {
  .service-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 7.5px 15px;
    border-radius: 10px;
    margin-bottom: 20px;
    background: var(--background-400);

    img {
      width: 45px;
      height: 45px;
      border-radius: 50%;
    }

    @media (min-width: 768px) {
      background: var(--background-400);
    }

    .el-button {
      min-width: 130px;
      @include buttonPrimary;
    }
  }
}
.dialog-content {
  width: 100%;
  position: relative;
  margin: 0 auto;
  padding-bottom: 50px;
  .el-dialog__headerbtn {
    position: absolute;
    top: 0;
    right: 0;
    display: block;
    font-size: 30px;
    .el-dialog__close {
      color: #fff !important;
    }
  }
  .vip-img {
    display: block;
    width: 360px;
    margin: 0 auto;
  }
  .vip-text {
    font-size: 16px;
    line-height: 24px;
    color: #fff;
    text-align: center;
    margin-top: 10px;
  }
  .vip-btn {
    display: block;
    margin: 30px auto 0;
    min-width: 150px;
    height: 48px;
    padding: 0 20px;
    background-image: linear-gradient(90deg, #f66d30 0%, #f8dfbd 100%), linear-gradient(#ffeac6, #ffeac6);
    background-blend-mode: normal, normal;
    box-shadow: 0px 2px 0px 0px #7c4323;
    border-radius: 8px;
    font-size: 16px;
  }
  &.isMobile {
    padding-bottom: 40px;
    .el-dialog__headerbtn {
      right: 10px;
      font-size: 24px;
    }
    .vip-img {
      width: 200px;
    }
    .vip-text {
      font-size: 14px;
      line-height: 20px;
      margin-top: 10px;
      max-width: 320px;
    }
    .vip-btn {
      min-width: 120px;
      height: 35px;
      font-size: 14px;
      padding: 0 15px;
      margin-top: 24px;
    }
  }
}
::v-deep .service-channel-dialog.el-dialog {
  max-width: 400px !important;
  width: 75% !important;
  // overflow: visible !important;
  background: transparent !important;
  margin-top: 0 !important;
  box-shadow: none;
  margin-bottom: 0;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  .el-dialog__header {
    display: none;
    padding: 0;
  }

  .el-dialog__body {
    padding: 0;
  }
}
</style>
